/* eslint-disable @typescript-eslint/no-explicit-any */
import { message } from 'antd';
import { intl } from '../../providers/IntlProvider';
import { addDocument, queryDocuments, removeDocument, updateDocument } from '../../services/api';
import { OrganisationDocumentsActionTypes } from '.';

export const getDocuments = () => async (dispatch): Promise<any> => {
  const response = await queryDocuments();
  dispatch({
    type: OrganisationDocumentsActionTypes.SET_DOCUMENTS,
    payload: response,
  });
};
export const add = ({ payload }) => async (dispatch): Promise<any> => {
  const response = await addDocument(payload);
  dispatch({
    type: OrganisationDocumentsActionTypes.SAVE,
    payload: response,
  });
  message.success(intl.formatMessage({ id: 'message.onFileSuccess' }));
};
export const remove = ({ payload }) => async (dispatch): Promise<any> => {
  await removeDocument(payload);
  dispatch({
    type: OrganisationDocumentsActionTypes.REMOVE_DOCUMENT,
    payload: {
      removeId: payload.id,
    },
  });
};
export const update = ({ payload }) => async (dispatch): Promise<any> => {
  const response = await updateDocument(payload);
  dispatch({
    type: OrganisationDocumentsActionTypes.SAVE,
    payload: response,
  });
  message.success(intl.formatMessage({ id: 'message.onFileUpdate' }));
};
